export { default as ListLocations } from './List'
export { default as CreateLocation } from './Create'
export { default as ShowLocation } from './Show'
export { default as EditLocation } from './Edit'
